import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import store from '../../store';

export default {
  name: "examList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      selectedYear: 0,
      selectedClass: 0,
      academic_year: 0,
      exam_name: '',
      class_id: 0,
      start_date: '',
      end_date: '',
      academicYearArr: null,
      classArr: [],
      examList: {},
      isLoading: false,
      search_status: false,
      searchBtnStatus: false,
      isSearched: false,
      searchedData: null,
    };
  },

  methods: {
    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
          this.getClass(this.selectedYear);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
      if (fieldName == "academic_year") {
        this.selectedClass = 0;
        this.classArr = [];
        this.getClass(val);
      }
    },

    selectEvent({ id }, fieldName) {
      id == 'Select' ? this.$set(this, fieldName, '') : this.$set(this, fieldName, id);
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getExamList(page = 1) {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      axios
        .get("/exam/list?page=" + page, request)
        .then((response) => {
          this.isLoading = false;
          this.search_status = false;
          this.examList = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Exam List API Error", error);
        });
    },

    reset() {
      this.selectedYear = 0;
      this.academic_year = 0;
      this.selectedClass = 0;
      this.class_id = 0;
      this.exam_name = '';
      this.classArr = [];
      this.start_date = '';
      this.end_date = '';
      this.isLoading = true;
      this.getExamList();
      this.isSearched = false;
    },

    searchExam(page = 1) {
      this.searchBtnStatus = true;
      this.isLoading = true;
      var params = {
        academic_year: this.academic_year,
        class_id: this.class_id,
        exam_name: this.exam_name,
        campus_id: store.state.user.campus_id,
        start_date: this.start_date,
        end_date: this.end_date
      };
      this.searchedData = {
        ...params,
        search_status: this.searchBtnStatus
      };
      this.isSearched = true;
      axios.get("/exam/search?page=" + page, { params })
        .then((response) => {
          this.search_status = true;
          this.examList = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Exam Search API Error", error);
        });
    },

    showCreate() {
      this.$router.push({
        path: "/exam/create"
      });
    },

    showDetail(exam_id) {
      this.$router.push({
        name: "examDetail",
        params: {
          exam_id: exam_id
        }
      });
    },

    showEdit(exam_id) {
      this.$router.push({
        name: "examEdit",
        params: {
          exam_id: exam_id
        }
      });
    },

    confirmDelete(exam_id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteExam(exam_id);
      } else {
        console.log("no");
      }
    },

    deleteExam(exam_id) {
      this.isLoading = true;
      axios.post("/exam/delete/" + exam_id, {
        campus_id: store.state.user.campus_id
      })
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            this.getExamList();
            this.$notification.success('Exam Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          } else if (response.status == 201) {
            this.isLoading = false;
            this.$notification.error("Student Gradings are Existing For This Exam.", {
              timer: 3,
              position: "bottomCenter",
            });
          } else {
            var message = "Exam data is already deleted.";
            if (response.data.errors.exam_id) {
              message = response.data.errors.exam_id[0];
            }
            this.$notification.error(message, {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "examList"
            });
            this.getExamList();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            this.isLoading = false;
            this.$notification.error("something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
          this.isLoading = false;
          console.log("Exam Delete Error->", error.response.data);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData ?
        {
          ...this.searchedData
        }
        : { campus_id: store.state.user.campus_id };
      axios.get('/exam/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `exam_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getExamList();
    this.getAcademicYear();
  },
};
